class SliderRotate extends HTMLElement {
    constructor() {
        super();
    } 
    
    connectedCallback(){
        this.initSlider();
    }

    initSlider(){
        this.swiper = new Swiper(".swiper-rotate", {
            loop: true,
            slidesPerView: "auto",
            spaceBetween: 49,
            centeredSlides: false,
            speed: 10000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
            freeMode: true,
            freeModeMomentum: false, 
        });
    };
}



customElements.define('slider-rotate', SliderRotate);